import { render, staticRenderFns } from "./IpgForm.vue?vue&type=template&id=088b46d6&scoped=true"
import script from "./IpgForm.vue?vue&type=script&lang=js"
export * from "./IpgForm.vue?vue&type=script&lang=js"
import style0 from "./IpgForm.vue?vue&type=style&index=0&id=088b46d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b46d6",
  null
  
)

export default component.exports